<ion-item *ngFor="let field of fieldDefinitions; trackBy: ticketTypeFieldsTrackBy" class="align-top">
  <ion-label slot="start" text-wrap>
    <p>{{ field.label }}</p>
  </ion-label>
  <ion-chip
    *ngIf="field.type === 'single-select'"
    mode="ios"
    class="select-chip select-outline"
    [outline]="true"
    (click)="showTicketTypeFieldOptions(field)"
    [disabled]="disabled"
  >
    <ion-label>
      {{ getTicketTypeFieldLabel(field, getFieldValueAsString(field.id)) ?? 'None' }}
      <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
    </ion-label>
  </ion-chip>

  <ion-label text-wrap style="margin: 0" *ngIf="field.type === 'multi-select'">
    <ion-chip
      mode="ios"
      color="primary"
      class="chip tag-chip"
      *ngFor="let value of getFieldValueAsArray(field.id)"
      (click)="removeTicketTypeField(field, value)"
      [disabled]="disabled"
    >
      <ion-label> {{ getTicketTypeFieldLabel(field, value) }} </ion-label>
    </ion-chip>
    <ion-chip
      mode="ios"
      [outline]="true"
      class="chip"
      (click)="showTicketTypeFieldOptions(field)"
      [disabled]="disabled"
    >
      <ion-label>
        <span>Add...</span>
      </ion-label>
    </ion-chip>
  </ion-label>

  <ion-textarea
    *ngIf="field.type === 'long-answer'"
    [(ngModel)]="fieldValues[field.id]"
    autoGrow="true"
    (ionBlur)="didBlurTicketTypeField(field)"
    placeholder="No value set..."
    style="margin: 0 4px"
    [disabled]="disabled"
  ></ion-textarea>

  <ion-input
    *ngIf="field.type === 'short-answer'"
    [(ngModel)]="fieldValues[field.id]"
    (ionBlur)="didBlurTicketTypeField(field)"
    placeholder="No value set..."
    class="right-col-input-wrapper"
    [disabled]="disabled"
  ></ion-input>

  <ion-button
    color="dark"
    fill="clear"
    (click)="changeDateTicketTypeField(field)"
    *ngIf="field.type === 'date'"
    style="--padding-start: 6px"
    class="btn-small"
    [disabled]="disabled"
  >
    {{ getFieldValueForDate(field.id) | date: 'M/d/yyyy' }}
  </ion-button>

  <ion-checkbox
    *ngIf="field.type === 'checkbox'"
    [(ngModel)]="fieldValues[field.id]"
    (ionChange)="didBlurTicketTypeField(field)"
    class="right-col-input-wrapper"
    [disabled]="disabled"
  ></ion-checkbox>

  <ion-chip
    *ngIf="field.type === 'user-select'"
    mode="ios"
    class="select-chip select-outline"
    [outline]="true"
    (click)="showTicketTypeFieldOptions(field)"
    [disabled]="disabled"
  >
    <ion-label>
      {{ ticketTypeFieldLabels?.['user-select']?.[getFieldValueAsString(field.id)] ?? 'None' }}
      <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
    </ion-label>
  </ion-chip>

  <ion-label text-wrap style="margin: 0" *ngIf="field.type === 'multi-user-select'">
    <ion-chip
      mode="ios"
      color="primary"
      class="chip tag-chip"
      *ngFor="let value of getFieldValueAsArray(field.id)"
      (click)="removeTicketTypeField(field, value)"
      [disabled]="disabled"
    >
      <ion-label> {{ ticketTypeFieldLabels?.['user-select']?.[value] ?? 'None' }} </ion-label>
    </ion-chip>
    <ion-chip
      mode="ios"
      [outline]="true"
      class="chip"
      (click)="showTicketTypeFieldOptions(field)"
      [disabled]="disabled"
    >
      <ion-label>
        <span>Add...</span>
      </ion-label>
    </ion-chip>
  </ion-label>
  <ion-chip
    *ngIf="field.type === 'user-group-select'"
    mode="ios"
    class="select-chip select-outline"
    [outline]="true"
    (click)="showTicketTypeFieldOptions(field)"
    [disabled]="disabled"
  >
    <ion-label>
      {{ ticketTypeFieldLabels?.['user-group-select']?.[getFieldValueAsString(field.id)] ?? 'None' }}
      <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
    </ion-label>
  </ion-chip>

  <ion-label text-wrap style="margin: 0" *ngIf="field.type === 'multi-user-group-select'">
    <ion-chip
      mode="ios"
      color="primary"
      class="chip tag-chip"
      *ngFor="let value of getFieldValueAsArray(field.id)"
      (click)="removeTicketTypeField(field, value)"
      [disabled]="disabled"
    >
      <ion-label> {{ ticketTypeFieldLabels?.['user-group-select']?.[value] ?? 'None' }} </ion-label>
    </ion-chip>
    <ion-chip
      mode="ios"
      [outline]="true"
      class="chip"
      (click)="showTicketTypeFieldOptions(field)"
      [disabled]="disabled"
    >
      <ion-label>
        <span>Add...</span>
      </ion-label>
    </ion-chip>
  </ion-label>

  <!-- file upload case here-->
  <ion-list *ngIf="field.type === 'file-upload'" style="background-color: rgba(0, 0, 0, 0)">
    <!-- Display existing files -->
    <ion-item
      *ngFor="let attachmentId of getFieldValueAsArray(field.id)"
      lines="none"
      class="existing-file-item"
      style="--inner-padding-end: 0; --padding-start: 0"
    >
      <ion-button
        fill="clear"
        color="medium"
        (click)="removeTicketTypeField(field, attachmentId)"
        [disabled]="disabled"
        class="remove-button"
      >
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
      <app-mini-file-attachment-preview [id]="attachmentId" [size]="30" [conversationId]="conversationId" />
    </ion-item>

    <!-- Add upload interface directly -->
    <ion-item *ngIf="!disabled" lines="none">
      <!-- Only show upload if not disabled -->
      <div *ngIf="uploadingFieldId === field.id" class="upload-status">
        <ion-spinner name="crescent"></ion-spinner>
        <span class="upload-text">Uploading...</span>
      </div>
      <div *ngIf="uploadingFieldId !== field.id">
        <!-- Use unique id for label/input -->
        <label [for]="'ticket-type-file-upload-' + componentInstanceId + '-' + field.id" class="file-upload-label">
          <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>Upload file
        </label>
        <input
          [id]="'ticket-type-file-upload-' + componentInstanceId + '-' + field.id"
          type="file"
          (change)="handleFileUpload($event, field)"
          style="display: none"
        />
      </div>
    </ion-item>
  </ion-list>
</ion-item>
